import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GiftSvg = function GiftSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.237 3.055A3.73 3.73 0 0 1 8.842 2a3.73 3.73 0 0 1 2.908 1.391q.14-.176.303-.336A3.73 3.73 0 0 1 14.658 2c.977 0 1.914.38 2.605 1.055a3.56 3.56 0 0 1 1.079 2.547H16.79c0-.553-.225-1.084-.625-1.475-.4-.39-.942-.61-1.508-.61s-1.108.22-1.508.61c-.4.391-.625.922-.625 1.475h-1.55c0-.553-.225-1.084-.625-1.475-.4-.39-.943-.61-1.508-.61s-1.108.22-1.508.61c-.4.391-.625.922-.625 1.475H5.16c0-.955.387-1.872 1.078-2.547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 12.521V7.213h19v5.308h-.97V22H3.22v-9.479zm10.276 0h6.204v7.962h-6.205zm0-1.516h7.173V8.73h-7.174zM10.974 8.73v2.275H3.8V8.73zm0 3.791v7.962H4.77v-7.962z",
    clipRule: "evenodd"
  }));
};
export var Gift = function Gift(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GiftSvg
  }));
};